import CharacterForm from "@/characters/admin/form/CharacterForm.tsx";
import {useCallback, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import {SaveCharacterRequest} from "@/characters/admin/form/CharacterFormSchema.ts";
import {useSaveCharacterMutation} from "@/characters/CharacterQueries.ts";
import ConfirmDialog from "@/components/forms/ConfirmDialog.tsx";
import {useUnsavedChangesGuard} from "@/hooks/useUnsavedChangesGuard.ts";

export default function CharacterCreateView() {
    const navigate = useNavigate();
    const location = useLocation();
    const {campaignPath} = useCampaign();
    const saveMutation = useSaveCharacterMutation();
    const [dirty, setDirty] = useState(false);
    const {run: guardNavigation, dialogProps} = useUnsavedChangesGuard(dirty, {
        title: "Neuen Charakter verwerfen?",
        description: "Die bereits vorgenommenen Eingaben gehen verloren.",
        confirm: "Eingaben verwerfen",
    });

    const onSubmit = async (character: SaveCharacterRequest) => {
        const saved = await saveMutation.mutateAsync(character);
        setDirty(false);
        navigate({pathname: campaignPath(`characters/${saved.id}/edit`), search: location.search}, {replace: true});
        return saved;
    }

    const cancel = useCallback(() => guardNavigation(() => {
        setDirty(false);
        navigate({pathname: campaignPath("characters"), search: location.search}, {replace: true});
    }), [campaignPath, guardNavigation, location.search, navigate]);

    return (
        <>
            <title>{`Neuer Charakter | DireDawn`}</title>
            <ConfirmDialog {...dialogProps}/>
            <CharacterForm onSubmit={onSubmit} onCancel={cancel} onDirtyChange={setDirty}/>
        </>
    );
}
